import { atom } from 'recoil'

export const influencerState =  atom({
    key: "influencerState",
    default: undefined
})

// 마이데이터 refresh 상태
export const mydataRefreshState = atom({
    key: "mydataRefreshState",
    default: "N"
});